<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('clientPackage') }}
        </h1>
      </div>
    </div>
    <client-package-list></client-package-list>
  </main>
</template>

<script>
import ClientPackageList from "./ClientPackageList";

export default {
  components: {
    ClientPackageList,
  },
}
</script>